<template>
  <div class="content">
    <h2 class="pl-3">{{ father }} | Docentes</h2>
    <v-dialog v-model="ventanaMateriasDeProfesor" width="800px">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title">Información Docente</v-card-title>
        <materias :idProfesor="idprofesor_seleccionado" class="estilo_ventana" />
      </v-card>
    </v-dialog>
    <template>
      <v-card class="pa-3 ma-3">
        <v-card-title>
          <v-row justify="center">
            <v-col cols="6">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
                solo
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="profesores"
          :search="search"
          ref="lista_profesores"
          :loading="loadingDocentes"
          loading-text="Cargando Datos... Porfavor espere"
        >
          <template v-slot:item.estado_profesor="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  :class="[item.estado_profesor != '1'? 'redColor' : 'greenColor']"
                >{{(item.estado_profesor!=1)? 'mdi-emoticon-sad-outline': 'mdi-emoticon-excited-outline'}}</v-icon>
              </template>
              <span>{{item.estado_profesor != '1'? 'Deshabilitado' : 'Habilitado'}}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.mas="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="mostrarOcultar_ventanaMateriasDeProfesor(item.idprofesor)"
                >mdi-magnify</v-icon>
              </template>
              <span>Ver Más</span>
            </v-tooltip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="cambiarEstadoDocente(item)"
                  :class="[item.estado_profesor != '1'? 'greenColor' : 'redColor']"
                >{{(item.estado_profesor!=1)? 'mdi-check-bold': 'mdi-close-thick'}}</v-icon>
              </template>
              <span>{{item.estado_profesor != '1'? 'Habilitar Docente' : 'Deshabilitar Docente'}}</span>
            </v-tooltip>
          </template>

          <template v-slot:no-data>
            <div class="text-xs-center">No hay Docentes Cargados</div>
          </template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
import materias from "./materiasDocente";

export default {
  data() {
    return {
      loadingDocentes: false,
      search: "",
      headers: [
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "nombre"
        },
        {
          text: "Apellido",
          sortable: true,
          value: "apellido"
        },
        { text: "Dni", sortable: false, class: "", value: "dni" },
        {
          text: "",
          value: "estado_profesor",
          sortable: false,
          width: 50
        },
        { text: "", value: "mas", sortable: false, width: 50 },
        { text: "", value: "actions", sortable: false, width: 50 }
      ],
      profesores: [],
      ventanaMateriasDeProfesor: false,
      idprofesor_seleccionado: ""
    };
  },
  props: ["father"],
  components: {
    materias
  },
  mounted: function() {
    this.listarDocentes();
  },
  methods: {
    listarDocentes() {
      this.loadingDocentes = true;
      let resultado = API.enviar("get", "obtenerProfesores", "");

      resultado
        .then(result => {
          /*console.log(
            "listarDocentes | methods | listarDocentes |  then: -> " +
              result.data.msj
          );*/

          if (result.data.msj == "ok") this.profesores = result.data.result;
        })
        .catch(error => {
          console.log(
            "listarDocentes | methods | listarDocentes |  catch: -> ",
            error
          );
        })
        .finally(() => {
          this.loadingDocentes = false;
        });
    },
    cambiarEstadoDocente: function(elem) {
      //console.log(elem);
      let param =
        "idProfesor=" + elem.idprofesor + "&estado=" + elem.estado_profesor;
      let resultadoEditar = API.enviar("get", "cambiarEstadoDocente", param);

      resultadoEditar
        .then(() => {
          this.listarDocentes();
        })
        .catch(error => {
          console.log("Catch 1 cambiarEstadoUsuario !!!", error);
        });
    },
    mayus(str) {
      let srt_result = API.ucFirst(str);
      return srt_result;
    },
    mostrarOcultar_ventanaMateriasDeProfesor: function(idprofesor) {
      this.idprofesor_seleccionado = idprofesor;
      //console.log("idprofesor: ", idprofesor);
      this.ventanaMateriasDeProfesor = !this.ventanaMateriasDeProfesor;
    }
  }
};
</script>

<style scoped>
.content {
  width: 100%;
}

h2 {
  text-align: left;
  margin-bottom: 10px;
}

.greenColor {
  color: green;
}
.redColor {
  color: red;
}
.v-icon {
  cursor: pointer;
}
.estilo_ventana {
  padding-top: 15px;
  padding-bottom: 15px;
}

.v-data-table,
td {
  text-transform: capitalize !important;
}
</style>